import React, { Component, createRef, useContext } from 'react'
import Unity, { UnityContext } from "react-unity-webgl";
import WebGLSettings from '../../../Model Uploader/WebGLSettings'
import CircularProgress from '@material-ui/core/CircularProgress';
import {checkNotUndefindeNull} from '../../../../Templates/functions'
import axios from 'axios'
import * as THREE from 'three';
import { OBJLoader } from 'three/examples/jsm/loaders/OBJLoader';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
import { MTLLoader } from 'three/examples/jsm/loaders/MTLLoader';
import ModelControls from '../../../../Templates/ModelControls';
import { v4 as uuidv4 } from 'uuid';
import { LoadingContext } from '../../../../../LoadingContext';
// Create a custom thick arrow function
const createThickArrow = (origin, direction, length, color, shaftRadius = 0.02, headLength = 0.2 * length, headRadius = 0.1 * length) => {
    const arrow = new THREE.Group();
    
    // The shaft length is the arrow's total length minus the head length
    const shaftLength = length - headLength;
    
    // Create the shaft geometry (a cylinder oriented along Y)
    const shaftGeometry = new THREE.CylinderGeometry(shaftRadius, shaftRadius, shaftLength, 8);
    // Use MeshPhongMaterial instead of MeshBasicMaterial
    const shaftMaterial = new THREE.MeshPhongMaterial({ color });
    const shaft = new THREE.Mesh(shaftGeometry, shaftMaterial);
    // Position the shaft so its bottom is at the origin
    shaft.position.y = shaftLength / 2;
    arrow.add(shaft);
    
    // Create the head geometry (a cone oriented along Y)
    const headGeometry = new THREE.ConeGeometry(headRadius, headLength, 8);
    // Use MeshPhongMaterial for the head as well
    const headMaterial = new THREE.MeshPhongMaterial({ color });
    const head = new THREE.Mesh(headGeometry, headMaterial);
    // Position the head so its tip is at the arrow's total length
    head.position.y = shaftLength + headLength / 2;
    arrow.add(head);
    
    // Default arrow orientation and positioning
    arrow.quaternion.setFromUnitVectors(new THREE.Vector3(0, 1, 0), direction.clone().normalize());
    arrow.position.copy(origin);
    
    return arrow;
};
class ModelDisplay extends Component {
    static contextType = LoadingContext;

    constructor(props) {
        super()
        this.state = {
            webGLLoading: true,
            cameraData: props.model && props.model.cameraData ? props.model.cameraData : {},
            progression: 0,
            authSent: false,
            loadedAssetBundles: false,
            modelsLoaded: false,
            webGLUsingInputs: true,
            brightness: true,
            hasError: false,
            view: false
        }
        this.modelRef = createRef()
        this.threeJSContainer = createRef();
        this.unityContext = new UnityContext({
            canvasHeight: "20px",
            codeUrl: "/builds/ModelViewer.wasm",
            frameworkUrl: "/builds/ModelViewer.framework.js",
            dataUrl: "/builds/ModelViewer.data",
            loaderUrl: "/builds/ModelViewer.loader.js",
        })
        // this.unityContext.on("click",() => {
        //     alert("clicked on unity ")
        // })

        this.unityContext.on("progress", progression => {
            this.setState({
                progression
            })
        })
        //when the webgl load onto the page
        this.unityContext.on("loaded", () => {
            this.setState({ webGLLoading: false })
           if(checkNotUndefindeNull(props.updateUnityContext) && typeof props.updateUnityContext == "function") {
            // //console.log("model loaded")
            props.updateUnityContext(this.unityContext,false)
        }
        })


        //after load asset bundles
        this.unityContext.on("modelsLoaded", () => {this.setState({modelsLoaded: true})
            //    //console.log("model loaded")
            if(checkNotUndefindeNull(props.updateUnityContext) && typeof props.updateUnityContext == "function") {
               
                props.updateUnityContext(this.unityContext,true)
            }
        })  
           
        
         this.unityContext.on("canvas", function (canvas) {
             //let webglWindow = document.getElementById("webGL-window");
             //let width = 600;
             ///let height = 400;
             //if (typeof webglWindow != "undefined" && webglWindow != null){
              //   //console.log("webgl")
              //   //console.log(document.getElementById("webGL-window").clientWidth)
                 //width =  document.getElementById("webGL-window").clientWidth;
                // height = document.getElementById("webGL-window").clientHeight;
             //}
             if(canvas != null){
              //  canvas.width = width;
               // canvas.height = height;
             }
             
            //props.updateUnityContext(this.unityContext);
           });

      
        

        this.unityContext.on("toggleColorPicker", this.toggleWebGLSettings);
        //when the camera icon is pressed

        this.unityContext.on("receiveUnityImage", (base64Img) => this.downloadImage(base64Img))

        //these are documented as part of library but do not function as intended
        //only catches run time errors
        this.unityContext.on("error", message => {
            this.setState({
                hasError: true,
                modelsLoaded: false,
                errorMessage: message
            });
        })

        this.unityContext.on("quitted", () => {
            //console.log("unity has quit")
            if(checkNotUndefindeNull(props.updateUnityContext) && typeof props.updateUnityContext == "function") {
                props.updateUnityContext(null,false)
            }
        });

        this.unityContext.send(
            "Manager",
            "WebGLUseInputs",
            0
        );
        this.setState({
            webGLUsingInputs: false
        })
    }

    componentDidMount = () => {
        console.log("props" , this.props)
        this.initThreeJSViewer();
        //console.log("view " + this.state.view);
        // Listen for the custom event 'annotationSelected'
        document.addEventListener("annotationSelected", this.handleAnnotationSelected);
        // Existing Unity setup
        document.addEventListener('mousedown', this.handleClickOutside);
        this.props.updateUnityContext(this.unityContext, false);
        
        // DEBUG: Expose test method to window for console access
        // window.testCameraPosition = this.testCameraPosition;
        window.modelDisplayRef = this;
    }

    componentWillUnmount = () => {
        document.removeEventListener('mousedown', this.handleClickOutside);
        window.removeEventListener('resize', this.handleWindowResize);
        document.removeEventListener("annotationSelected", this.handleAnnotationSelected);
        // Remove event listeners
        if (this.threeJSContainer.current) {
            this.threeJSContainer.current.removeEventListener('click', this.handleModelClick);
            this.threeJSContainer.current.removeEventListener('mousemove', this.handleMouseMove);
        }
        
        // Clean up Three.js resources
        if (this.frameId) {
            cancelAnimationFrame(this.frameId);
        }
        
        if (this.renderer) {
            this.renderer.dispose();
        }
        
        // DEBUG: Clean up window references
        if (window.testCameraPosition) {
            delete window.testCameraPosition;
        }
        if (window.modelDisplayRef) {
            delete window.modelDisplayRef;
        }
    }

    componentDidUpdate(prevProps) {
        // Check if the model's texture_config has changed and reload textures if so
        if (this.props.model && prevProps.model && 
            this.props.model.texture_config !== prevProps.model.texture_config) {
            console.log('Model texture_config changed, reloading textures...');
            this.applySavedTextures();
        }
    }

    // ----------------------------------------------------------------
    // Three.js viewer setup method
    initThreeJSViewer = () => {
        // Ensure container exists
        if (!this.threeJSContainer.current) return;
        
        // Create scene, camera, and renderer
        this.scene = new THREE.Scene();
        this.scene.background = new THREE.Color(0xf0f0f0);
        
        this.camera = new THREE.PerspectiveCamera(
            45,
            this.threeJSContainer.current.clientWidth / this.threeJSContainer.current.clientHeight,
            0.1,
            1000
        );
        this.camera.position.set(0, 5, 10);
        
        this.renderer = new THREE.WebGLRenderer({ antialias: true });
        this.renderer.setSize(
            this.threeJSContainer.current.clientWidth,
            this.threeJSContainer.current.clientHeight
        );
        this.renderer.setPixelRatio(window.devicePixelRatio);
        
        // Append renderer to the container
        this.threeJSContainer.current.appendChild(this.renderer.domElement);
        
        // Add lights
        const ambientLight = new THREE.AmbientLight(0xffffff, 0.2);
        this.scene.add(ambientLight);
        
        const directionalLight = new THREE.DirectionalLight(0xffffff, 0.8);
        directionalLight.position.set(1, 1, 1);
        this.scene.add(directionalLight);
        
        // Add orbit controls
        this.controls = new OrbitControls(this.camera, this.renderer.domElement);
        this.controls.enableDamping = true;
        this.controls.dampingFactor = 0.05;
        
        // In initThreeJSViewer method:
        const gridHelper = new THREE.GridHelper(100, 100);
        gridHelper.position.y = -0.01; // initial value
        this.scene.add(gridHelper);
        this.gridHelper = gridHelper; // store reference for later
        
        


        // Setup raycaster for click detection
        this.raycaster = new THREE.Raycaster();
        this.mouse = new THREE.Vector2();
        
        if (!this.props.isPDFViewer){
            // Add click event listener
            this.threeJSContainer.current.addEventListener('click', this.handleModelClick);
            // Add click event listener
            this.threeJSContainer.current.addEventListener('mousemove', this.handleMouseMove); 
        }
        // Load GLB model
        this.loadGLBModel();
        // this.loadGLTFModel();
        
        // Handle window resize
        window.addEventListener('resize', this.handleWindowResize);
        
        // Animation loop
        const animate = () => {
            this.frameId = requestAnimationFrame(animate);
            this.controls.update();
            this.renderer.render(this.scene, this.camera);
        };
        animate();
    }

    // This event listener is triggered when an annotation span is clicked in WIAuthorSteps.
    handleAnnotationSelected = (event) => {
        const { annotationData, annotationID } = event.detail;
        console.log("ModelDisplay received annotation data:", annotationData || annotationID);
        
        // Reset all highlights when an annotation is selected
        this.resetHighlights();
        
        if (annotationData && annotationData.position) {
            
            // Update camera if camera data is provided
            if (annotationData.cameraPosition && annotationData.cameraRotation) {
                // Debug logging - current state
                console.log("=== CAMERA DEBUG INFO ===");
                console.log("Current camera position:", this.camera.position.x, this.camera.position.y, this.camera.position.z);
                console.log("Current camera rotation:", this.camera.quaternion.x, this.camera.quaternion.y, this.camera.quaternion.z, this.camera.quaternion.w);
                console.log("Current controls target:", this.controls.target.x, this.controls.target.y, this.controls.target.z);
                
                // Target positions from annotation
                console.log("Target camera position:", annotationData.cameraPosition.x, annotationData.cameraPosition.y, annotationData.cameraPosition.z);
                console.log("Target camera rotation:", annotationData.cameraRotation.x, annotationData.cameraRotation.y, annotationData.cameraRotation.z, annotationData.cameraRotation.w);
                
                // Temporarily disable controls to prevent interference
                this.controls.enabled = false;
                
                const newCamPos = new THREE.Vector3(
                    annotationData.cameraPosition.x,
                    annotationData.cameraPosition.y,
                    annotationData.cameraPosition.z
                );
                const newCamQuat = new THREE.Quaternion(
                    annotationData.cameraRotation.x,
                    annotationData.cameraRotation.y,
                    annotationData.cameraRotation.z,
                    annotationData.cameraRotation.w
                );
                
                // Set camera position and rotation
                this.camera.position.copy(newCamPos);
                this.camera.quaternion.copy(newCamQuat);
                
                // Calculate where the camera should be looking based on the annotation position
                const annotationPos = new THREE.Vector3(
                    annotationData.position.x,
                    annotationData.position.y,
                    annotationData.position.z
                );
                
                // Update the controls target to the annotation position
                this.controls.target.copy(annotationPos);
                
                // Force update camera matrix
                this.camera.updateMatrixWorld();
                
                // Re-enable controls and update
                this.controls.enabled = true;
                this.controls.update();
                
                // Debug logging - after update
                console.log("After update camera position:", this.camera.position.x, this.camera.position.y, this.camera.position.z);
                console.log("After update camera rotation:", this.camera.quaternion.x, this.camera.quaternion.y, this.camera.quaternion.z, this.camera.quaternion.w);
                console.log("After update controls target:", this.controls.target.x, this.controls.target.y, this.controls.target.z);
                console.log("=== END CAMERA DEBUG ===");
            }
            
            // Remove previous arrow if it exists
            if (this.lastArrowHelper) {
                this.scene.remove(this.lastArrowHelper);
            }
            
            // Use the provided annotation position
            const clickedPoint = new THREE.Vector3(
                annotationData.position.x,
                annotationData.position.y,
                annotationData.position.z
            );
            console.log('Annotation coordinates:', clickedPoint.x, clickedPoint.y, clickedPoint.z);
            
            // Cast ray from camera to point to find intersections
            const directionRay = new THREE.Vector3().subVectors(clickedPoint, this.camera.position).normalize();
            this.raycaster.set(this.camera.position, directionRay);
            const intersects = this.raycaster.intersectObjects(this.scene.children, true);
            
            // Filter to get only mesh intersections
            const meshIntersections = intersects.filter(intersection => 
                intersection.object.isMesh && 
                intersection.object.userData.isPickable
            );
            
            // Get the face normal (closest to our clicked point)
            let faceNormal = new THREE.Vector3();
            if (meshIntersections.length > 0 && meshIntersections[0].face) {
                faceNormal.copy(meshIntersections[0].face.normal).transformDirection(meshIntersections[0].object.matrixWorld);
            } else {
                // Fallback if no intersection found
                faceNormal.set(0, 1, 0); 
            }
            
            // Create a minimal offset to ensure the arrow is outside the mesh
            const offsetDistance = 0.01;
            const arrowTip = clickedPoint.clone().add(faceNormal.clone().multiplyScalar(offsetDistance));
            
            // Use the face normal (inverted) as the arrow direction
            const arrowDirection = faceNormal.clone().negate().normalize();
            
            const arrowLength = 1;
            
            // Function to check if an arrow in a specific direction would intersect with meshes
            const checkArrowIntersection = (direction) => {
                const testOrigin = arrowTip.clone().sub(direction.clone().multiplyScalar(arrowLength));
                const ray = new THREE.Raycaster(testOrigin, direction, 0, arrowLength);
                const intersections = ray.intersectObjects(this.scene.children, true)
                    .filter(hit => hit.object.isMesh);
                return intersections.length > 0;
            };
            
            // Find a good direction for the arrow
            let finalArrowDirection = arrowDirection.clone();
            let intersectionFound = checkArrowIntersection(finalArrowDirection);
            let angleOffset = 0;
            const maxAngleOffset = Math.PI / 4; // maximum rotation: 45 degrees
            const angleIncrement = 0.1; // adjust increment as needed
            
            while (intersectionFound && angleOffset < maxAngleOffset) {
                angleOffset += angleIncrement;
                finalArrowDirection = arrowDirection.clone();
                finalArrowDirection.applyAxisAngle(this.camera.up, angleOffset);
                intersectionFound = checkArrowIntersection(finalArrowDirection);
            }
            
            // Calculate the arrow origin so the tip is at the clicked point
            const arrowOrigin = arrowTip.clone().sub(finalArrowDirection.clone().multiplyScalar(arrowLength));
            
            // Create the thick arrow with a green color (0x00ff00)
            const arrowColor = 0x00ff00;
            const thickArrow = createThickArrow(
                arrowOrigin,
                finalArrowDirection,
                arrowLength,
                arrowColor,
                arrowLength * 0.03,
                arrowLength * 0.2,
                arrowLength * 0.1
            );
            
            // Ensure the arrow is visible through objects
            thickArrow.traverse(obj => {
                if (obj.isMesh) {
                    obj.material.depthTest = false;
                    obj.material.transparent = true;
                    obj.material.opacity = 0.8;
                    obj.material.emissive = new THREE.Color(arrowColor);
                    obj.material.emissiveIntensity = 0.5;
                    obj.renderOrder = 999;
                }
            });
            
            this.scene.add(thickArrow);
            this.lastArrowHelper = thickArrow;
            
        } else if (annotationID) {
            console.log("No complete annotation data found; received only ID: ", annotationID);
        }
    };



    // Add helper methods for continuous shift, turn, and zoom
    startContinuousShift = (dirX, dirY) => {
        this.shifting = true;
        this.lastShiftTime = null;
        const shiftAnimate = (time) => {
            if (!this.shifting) {
                this.lastShiftTime = null;
                return;
            }
            if (this.lastShiftTime === null) {
                this.lastShiftTime = time;
            }
            const deltaTime = time - this.lastShiftTime;
            const speed = 0.003; // adjust as needed
            const distance = speed * deltaTime;
            // Get the camera's forward vector
            const forward = new THREE.Vector3();
            this.camera.getWorldDirection(forward);
            // Compute the right vector from forward and up
            const right = new THREE.Vector3();
            right.crossVectors(forward, this.camera.up).normalize();
            // Use the camera's up vector
            const up = this.camera.up.clone().normalize();
            // Calculate the shift vector
            const shift = new THREE.Vector3();
            shift.addScaledVector(right, dirX * distance);
            shift.addScaledVector(up, dirY * distance);
            // Apply the shift to the camera's position and the controls target
            this.camera.position.add(shift);
            if (this.controls) {
                this.controls.target.add(shift);
            }
            this.lastShiftTime = time;
            requestAnimationFrame(shiftAnimate);
        };
        requestAnimationFrame(shiftAnimate);
    };

    stopContinuousShift = () => {
        this.shifting = false;
    };

    onShiftUp = () => { this.startContinuousShift(0, 1); }
    onShiftDown = () => { this.startContinuousShift(0, -1); }
    onShiftLeft = () => { this.startContinuousShift(-1, 0); }
    onShiftRight = () => { this.startContinuousShift(1, 0); }
    onShiftStop = () => { this.stopContinuousShift(); }

    rotateLeft = (angle) => {
        // Rotate horizontally about the world up axis (0,1,0)
        const axis = new THREE.Vector3(0, 1, 0);
        // Get offset from target to camera
        const offset = new THREE.Vector3().subVectors(this.camera.position, this.controls.target);
        offset.applyAxisAngle(axis, angle);
        this.camera.position.copy(this.controls.target).add(offset);
        this.camera.lookAt(this.controls.target);
    };

    rotateUp = (angle) => {
        // Rotate vertically about the camera's right vector
        const right = new THREE.Vector3();
        right.crossVectors(this.camera.getWorldDirection(new THREE.Vector3()), this.camera.up).normalize();
        const offset = new THREE.Vector3().subVectors(this.camera.position, this.controls.target);
        offset.applyAxisAngle(right, angle);
        this.camera.position.copy(this.controls.target).add(offset);
        this.camera.lookAt(this.controls.target);
    };

    startContinuousTurn = (direction) => {
        this.turning = true;
        this.lastTurnTime = null;
        const turnAnimate = (time) => {
            if (!this.turning) {
                this.lastTurnTime = null;
                return;
            }
            if (this.lastTurnTime === null) {
                this.lastTurnTime = time;
            }
            const deltaTime = time - this.lastTurnTime;
            const angularSpeed = 0.001; // radians per ms
            const angle = angularSpeed * deltaTime;
            switch(direction) {
                case 'up':
                    this.rotateUp(-angle);
                    break;
                case 'down':
                    this.rotateUp(angle);
                    break;
                case 'left':
                    this.rotateLeft(-angle);
                    break;
                case 'right':
                    this.rotateLeft(angle);
                    break;
                default:
                    break;
            }
            this.lastTurnTime = time;
            requestAnimationFrame(turnAnimate);
        };
        requestAnimationFrame(turnAnimate);
    };

    stopContinuousTurn = () => {
        this.turning = false;
    };

    onTurnUp = () => { this.startContinuousTurn('up'); }
    onTurnDown = () => { this.startContinuousTurn('down'); }
    onTurnLeft = () => { this.startContinuousTurn('left'); }
    onTurnRight = () => { this.startContinuousTurn('right'); }
    onTurnStop = () => { this.stopContinuousTurn(); }

    startContinuousZoom = (direction) => {
        this.zooming = true;
        this.lastZoomTime = null;
        const zoomAnimate = (time) => {
            if (!this.zooming) {
                this.lastZoomTime = null;
                return;
            }
            if (this.lastZoomTime === null) {
                this.lastZoomTime = time;
            }
            const deltaTime = time - this.lastZoomTime;
            const zoomSpeed = 0.005; // adjust speed as needed
            const move = zoomSpeed * deltaTime;
            // Compute unit vector from camera to target
            const vec = new THREE.Vector3();
            vec.subVectors(this.controls.target, this.camera.position).normalize();
            if (direction === 'in') {
                this.camera.position.addScaledVector(vec, move);
            } else if (direction === 'out') {
                this.camera.position.addScaledVector(vec, -move);
            }
            this.camera.lookAt(this.controls.target);
            this.lastZoomTime = time;
            requestAnimationFrame(zoomAnimate);
        };
        requestAnimationFrame(zoomAnimate);
    };

    stopContinuousZoom = () => {
        this.zooming = false;
    };

    onZoomInDown = () => { this.startContinuousZoom('in'); }
    onZoomOutDown = () => { this.startContinuousZoom('out'); }
    onZoomStop = () => { this.stopContinuousZoom(); }







    handleMouseMove = (event) => {
        // Only process if we're not dragging with controls
        if (this.controls.enabled) {
            // Calculate mouse position in normalized device coordinates
            const rect = this.threeJSContainer.current.getBoundingClientRect();
            this.mouse.x = ((event.clientX - rect.left) / this.threeJSContainer.current.clientWidth) * 2 - 1;
            this.mouse.y = -((event.clientY - rect.top) / this.threeJSContainer.current.clientHeight) * 2 + 1;
            
            // Update raycaster
            this.raycaster.setFromCamera(this.mouse, this.camera);
            
            // Find intersections with meshes in the scene
            const intersects = this.raycaster.intersectObjects(this.scene.children, true);
            
            // Filter intersections to only include actual meshes (not GridHelper, etc)
            const meshIntersections = intersects.filter(intersection => 
                intersection.object.isMesh && 
                intersection.object.userData.isPickable && 
                intersection.object.type !== 'GridHelper'
            );
            
            // Change cursor to crosshair only if hovering over an actual mesh object
            if (meshIntersections.length > 0) {
                this.threeJSContainer.current.style.cursor = 'crosshair';
            } else {
                this.threeJSContainer.current.style.cursor = 'default';
            }
        }
    }





    handleModelClick = (event) => {

        const rect = this.threeJSContainer.current.getBoundingClientRect();
        this.mouse.x = ((event.clientX - rect.left) / this.threeJSContainer.current.clientWidth) * 2 - 1;
        this.mouse.y = -((event.clientY - rect.top) / this.threeJSContainer.current.clientHeight) * 2 + 1;
        
        // Update raycaster
        this.raycaster.setFromCamera(this.mouse, this.camera);
        
        // Find intersections with ALL meshes in the scene (recursive=true)
        const intersects = this.raycaster.intersectObjects(this.scene.children, true);
        
        // Filter intersections to only include actual meshes (not GridHelper, etc)
        const meshIntersections = intersects.filter(intersection => 
            intersection.object.isMesh && 
            intersection.object.userData.isPickable && 
            intersection.object.type !== 'GridHelper'
        );
        
        if (meshIntersections.length > 0) {
            // Remove previous arrow if it exists
            if (this.lastArrowHelper) {
                this.scene.remove(this.lastArrowHelper);
            }
    
            const intersection = meshIntersections[0];
            const clickedPoint = intersection.point;
            console.log('Clicked coordinates:', clickedPoint.x, clickedPoint.y, clickedPoint.z);
    
            // Get the face normal (direction perpendicular to surface)
            let faceNormal = new THREE.Vector3();
            if (intersection.face) {
                faceNormal.copy(intersection.face.normal).transformDirection(intersection.object.matrixWorld);
            }
    
            // Create a minimal offset to ensure the arrow is outside the mesh
            const offsetDistance = 0.01;
            const arrowTip = clickedPoint.clone().add(faceNormal.multiplyScalar(offsetDistance));
    
            // Use the face normal (inverted) as the arrow direction
            const arrowDirection = faceNormal.clone().negate().normalize();
    
            const arrowLength = 1.5;
            
            // Function to check if an arrow in a specific direction would intersect with meshes
            const checkArrowIntersection = (direction) => {
                const testOrigin = arrowTip.clone().sub(direction.clone().multiplyScalar(arrowLength));
                const ray = new THREE.Raycaster(testOrigin, direction, 0, arrowLength);
                const intersections = ray.intersectObjects(this.scene.children, true)
                    .filter(hit => hit.object !== intersection.object && hit.object.isMesh);
                return intersections.length > 0;
            };
    
            // Find a good direction for the arrow
            let finalArrowDirection = arrowDirection.clone();
            let intersectionFound = checkArrowIntersection(finalArrowDirection);
    
            if (intersectionFound) {
                // Try different angles to find a non-intersecting direction
                // ...existing code for finding arrow direction...
                // This code will adjust finalArrowDirection if needed
            }
    
            // Calculate the arrow origin so the tip is at the clicked point
            const arrowOrigin = arrowTip.clone().sub(finalArrowDirection.clone().multiplyScalar(arrowLength));
    

            
            // Regular arrow creation (not an annotation)
            const arrowColor = 0xff0000;
            const thickArrow = createThickArrow(
                arrowOrigin, 
                finalArrowDirection, 
                arrowLength, 
                arrowColor, 
                arrowLength * 0.03,
                arrowLength * 0.2,
                arrowLength * 0.1
            );
            
            // Make arrow always visible even through objects
            thickArrow.traverse(obj => {
                if (obj.isMesh) {
                    obj.material.depthTest = false;
                    obj.material.transparent = true;
                    obj.material.opacity = 0.8;
                    obj.material.emissive = new THREE.Color(arrowColor);
                    obj.material.emissiveIntensity = 0.5;
                    obj.renderOrder = 999;
                }
            });
            
            this.scene.add(thickArrow);
            // Generate annotation ID
            const annotationId = uuidv4();

            // Store ID in the arrow's userData
            thickArrow.userData.annotationId = annotationId;

            
            // Store reference for later access
            this.annotationMarkers = this.annotationMarkers || {};
            this.annotationMarkers[annotationId] = thickArrow;
            
            // Create annotation data
            const annotationData = this.createAnnotationData(annotationId, clickedPoint, finalArrowDirection);
            this.props.addAnnotation(annotationData);
            this.lastArrowHelper = thickArrow;
            
            // Existing highlighting code
            const objectHit = meshIntersections[0].object;
            this.resetHighlights();
            
            // Store original material if not already stored
            if (!objectHit.userData.originalMaterial) {
                objectHit.userData.originalMaterial = objectHit.material.clone();
            }
            
            // Handle part highlighting
            const partGroup = objectHit.userData.partGroup;
            
            if (partGroup) {
                // Highlight all objects in the same group
                this.scene.traverse((node) => {
                    if (node.isMesh && node.userData.partGroup === partGroup) {
                        this.highlightObject(node);
                    }
                });
            } else {
                // Highlight just this object if no group found
                this.highlightObject(objectHit);
            }
        }
    }


    createAnnotationData = (annotationId, clickedPoint, direction) => {
        // Get camera position and rotation for the annotation
        const cameraPosition = this.camera.position.clone();
        const cameraQuaternion = this.camera.quaternion.clone();
        
        // Create the annotation data object to match what Unity would send
        const annotationData = {
            id: annotationId,
            text: this.props.textSelectedInEditor || "",
            annotationType: 0,
            scale: 1.0,
            position: {
                x: clickedPoint.x,
                y: clickedPoint.y,
                z: clickedPoint.z
            },
            title: "",
            cameraPosition: {
                x: cameraPosition.x,
                y: cameraPosition.y,
                z: cameraPosition.z
            },
            cameraRotation: {
                x: cameraQuaternion.x,
                y: cameraQuaternion.y,
                z: cameraQuaternion.z,
                w: cameraQuaternion.w
            },
            gameObject: {
                m_FileID: 0,
                m_PathID: 0
            }
        };
        return JSON.stringify(annotationData)
    }



    resetHighlights = () => {
        //console.log("Resetting all highlights");
        let resetCount = 0;
        
        // Traverse all objects in the scene and reset their materials
        this.scene.traverse((node) => {
            if (node.isMesh && node.userData.isHighlighted) {
                if (node.userData.originalMaterial) {
                    // Check if the object has an applied texture that should be restored
                    if (node.userData.appliedTexture) {
                        // Restore the textured material
                        const texturedMaterial = node.userData.originalMaterial.clone();
                        texturedMaterial.map = node.material.map; // Preserve the current texture
                        texturedMaterial.needsUpdate = true;
                        node.material = texturedMaterial;
                    } else {
                        // Restore the original material without texture
                        node.material = node.userData.originalMaterial.clone();
                    }
                    node.userData.isHighlighted = false;
                    resetCount++;
                } else {
                    console.warn("Highlighted mesh missing original material:", node.name);
                }
            }
        });
        
        //console.log(`Reset ${resetCount} highlighted objects`);
    }
    highlightObject = (object) => {
        const partColors = [
            0xFFFFFF
            // 0x8C9EFF, // Blue
            // 0x9CCC65, // Green
            // 0xFFB74D, // Orange
            // 0x4FC3F7, // Light blue
            // 0xF06292, // Pink
            // 0xBA68C8  // Purple
        ];
        if (!object.isMesh) {
            console.warn("Cannot highlight non-mesh object:", object);
            return;
        }
        // Ensure original material is stored
        if (!object.userData.originalMaterial) {
            object.userData.originalMaterial = object.material.clone();
        }

        // Get the object's color index or use a default
        const colorIndex = object.userData.colorIndex || 0;
        const highlightColor = partColors[colorIndex % partColors.length];
        
        // Check if the object has an applied texture
        const hasAppliedTexture = object.userData.appliedTexture && object.material.map;
        
        let highlightMaterial;
        if (hasAppliedTexture) {
            // If the object has a texture, preserve it in the highlight material
            highlightMaterial = object.material.clone();
            // Just add emissive highlighting while preserving the texture
            highlightMaterial.emissive = new THREE.Color(highlightColor);
            highlightMaterial.emissiveIntensity = 0.3;
        } else {
            // If no texture, use the original color-based highlighting
            highlightMaterial = object.userData.originalMaterial.clone();
            highlightMaterial.color.setHex(highlightColor);
            highlightMaterial.emissive = new THREE.Color(highlightColor);
            highlightMaterial.emissiveIntensity = 0.2;
        }
        
        highlightMaterial.needsUpdate = true;
        
        // Apply the material
        object.material = highlightMaterial;
        object.userData.isHighlighted = true;
        
        if (this.props.onPartSelected) {
            this.props.onPartSelected(object.name || object.userData.partGroup, object);
        }
    }
    

    //TO USE TEXTURES
    // highlightObject = (object) => {
    //     if (!object.isMesh) {
    //         console.warn("Cannot highlight non-mesh object:", object);
    //         return;
    //     }
    //     // Ensure original material is stored
    //     if (!object.userData.originalMaterial) {
    //         object.userData.originalMaterial = object.material.clone();
    //     }
    
    //     const modelId = this.props.model?.temp_model_id || this.props.model?._id;
    //     const textureUrl = `http://${window.location.hostname}:5000/api/models/obj/${modelId}/Texturelabs_Wood_293XL.jpg`;
    
    //     const textureLoader = new THREE.TextureLoader();
    //     textureLoader.load(textureUrl, (texture) => {
    //         // Configure texture wrapping and repeat options
    //         texture.wrapS = THREE.RepeatWrapping;
    //         texture.wrapT = THREE.RepeatWrapping;
    //         texture.repeat.set(2, 2); // Adjust based on desired scaling
    
    //         // Clone original material and assign the texture
    //         const highlightMaterial = object.userData.originalMaterial.clone();
    //         highlightMaterial.map = texture;
    //         highlightMaterial.needsUpdate = true;
    //         object.material = highlightMaterial;
    //         object.userData.isHighlighted = true;
    //         if (this.props.onPartSelected) {
    //             this.props.onPartSelected(object.name || object.userData.partGroup, object);
    //         }
    //     },
    //     undefined,
    //     (error) => {
    //         console.error('Error loading texture:', error);
    //     });
    // }






    loadGLBModel = () => {
        // Get context functions using this.context (available due to static contextType)
        const { incrementRequestCount, decrementRequestCount } = this.context;

        // Create loading manager to track progress
        const loadingManager = new THREE.LoadingManager();
        loadingManager.onProgress = (url, itemsLoaded, itemsTotal) => {
            //console.log(`Loading file: ${url} (${itemsLoaded}/${itemsTotal})`);
        };
        
        const modelId = this.props.model?.temp_model_id || this.props.model?._id;
        const modelPath = this.props.model.path;
        const gltfLoader = new GLTFLoader(loadingManager);
        const modelUrl = `${window.config.getApiBaseUrl()}/api/models/obj/${modelId}/${modelPath}`;
        
        // --- Increment counter before starting load ---
        incrementRequestCount(); 
        const partColors = [
            // 0x8C9EFF, // Blue
            // 0x9CCC65, // Green
            // 0xFFB74D, // Orange
            // 0x4FC3F7, // Light blue
            // 0xF06292, // Pink
            // 0xBA68C8  // Purple
        ];
        gltfLoader.load(
            modelUrl,
            (gltf) => { // --- onLoad (Success) ---
                const object = gltf.scene;
                //console.log('Model loaded successfully', object);
                
                // Look for obj group names and preserve them
                let partCounter = 0;
                const objectsMap = new Map(); // To group meshes by objects in OBJ file
                
                // First pass: identify groups based on obj names
                object.traverse((child) => {
                    if (child.isMesh) {
                        // If child has a parent that's not the root, use parent's name
                        if (child.parent && child.parent !== object) {
                            const objName = child.parent.name || `Part_${partCounter}`;
                            if (!objectsMap.has(objName)) {
                                objectsMap.set(objName, []);
                                partCounter++;
                            }
                            objectsMap.get(objName).push(child);
                        } else {
                            // If no parent or parent is root, use mesh name or generic name
                            const objName = child.name || `Part_${partCounter}`;
                            if (!objectsMap.has(objName)) {
                                objectsMap.set(objName, []);
                                partCounter++;
                            }
                            objectsMap.get(objName).push(child);
                        }
                    }
                });
                
                // Process meshes by group (using a consistent base color)
                objectsMap.forEach((meshes, objName) => {
                    const material = new THREE.MeshPhongMaterial({ color: 0xffffff });
                    
                    // Apply material and set name for each mesh in the group
                    meshes.forEach(mesh => {
                        // Store original material before setting the new one
                        mesh.material = material.clone();
                        mesh.userData.originalMaterial = material.clone();
                        mesh.name = objName; // Set proper name
                        mesh.userData.partGroup = objName; // Store group info for highlighting
                        mesh.userData.isPickable = true;
                        mesh.userData.isHighlighted = false;
                        mesh.userData.colorIndex = Array.from(objectsMap.keys()).indexOf(objName) % partColors.length;
                    });
                });
                
                // Debug output to see what groups were found
                //console.log("Identified object groups:", Array.from(objectsMap.keys()));
                
                // --- Centering and Scaling Logic ---
                this.scene.add(object);
                this.frameObject(object, this.camera, this.controls);

                // Apply saved textures if they exist
                this.applySavedTextures();

                this.setState({ modelsLoaded: true }, () => {
                    if (this.props.onModelsLoaded) {
                      this.props.onModelsLoaded(true);
                    }
                    // --- Decrement counter on successful load ---
                    decrementRequestCount(); 
                });
            },
            (xhr) => { // --- onProgress ---
                const percent = (xhr.loaded / xhr.total) * 100;
                //console.log(`Model ${percent.toFixed(2)}% loaded`);
            },
            (error) => { // --- onError ---
                console.error('Error loading model:', error);
                // --- Decrement counter on error ---
                decrementRequestCount(); 
            }
        );
    }

    // Apply saved textures from texture_config
    applySavedTextures = () => {
        const textureConfig = this.props.model?.texture_config;
        
        // If no texture config exists, skip texture application
        if (!textureConfig) {
            console.log('No texture configuration found for this model');
            return;
        }

        let parsedConfig;
        try {
            // Parse the JSON string
            parsedConfig = typeof textureConfig === 'string' ? JSON.parse(textureConfig) : textureConfig;
        } catch (error) {
            console.error('Error parsing texture configuration:', error);
            return;
        }

        if (!Array.isArray(parsedConfig)) {
            console.error('Texture configuration is not an array:', parsedConfig);
            return;
        }

        console.log('Applying saved textures:', parsedConfig);

        // Apply textures to each configured part group
        parsedConfig.forEach(config => {
            const { partGroup, texturePath, textureName } = config;
            
            if (!partGroup || !texturePath) {
                console.warn('Invalid texture config entry:', config);
                return;
            }

            // Find all meshes with the matching part group
            const meshesToTexture = [];
            this.scene.traverse((node) => {
                if (node.isMesh && node.userData.partGroup === partGroup) {
                    meshesToTexture.push(node);
                }
            });

            if (meshesToTexture.length === 0) {
                console.warn(`No meshes found for part group: ${partGroup}`);
                return;
            }

            // Load and apply the texture
            const textureLoader = new THREE.TextureLoader();
            textureLoader.load(
                texturePath,
                (texture) => {
                    // Configure texture wrapping and repeat options
                    texture.wrapS = THREE.RepeatWrapping;
                    texture.wrapT = THREE.RepeatWrapping;
                    texture.repeat.set(2, 2); // Adjust based on desired scaling

                    // Apply texture to all meshes in the part group
                    meshesToTexture.forEach(mesh => {
                        // Store original material if not already stored
                        if (!mesh.userData.originalMaterial) {
                            mesh.userData.originalMaterial = mesh.material.clone();
                        }

                        // Clone original material and assign the texture
                        const texturedMaterial = mesh.userData.originalMaterial.clone();
                        texturedMaterial.map = texture;
                        texturedMaterial.needsUpdate = true;
                        
                        // Apply the textured material
                        mesh.material = texturedMaterial;
                        
                        // Store texture info in userData for future reference
                        mesh.userData.appliedTexture = {
                            texturePath,
                            textureName,
                            textureIndex: config.textureIndex
                        };
                    });

                    console.log(`Applied texture "${textureName}" to part group "${partGroup}"`);
                },
                undefined,
                (error) => {
                    console.error(`Error loading texture for part group "${partGroup}":`, error);
                }
            );
        });
    }

    loadGLTFModel = () => {
        // Create loading manager to track progress
        const loadingManager = new THREE.LoadingManager();
        loadingManager.onProgress = (url, itemsLoaded, itemsTotal) => {
            //console.log(`Loading file: ${url} (${itemsLoaded}/${itemsTotal})`);
        };
        
        // Get model ID from props or use a default
        const modelId = this.props.model?.temp_model_id || this.props.model?._id || 'FC906219-77A9-471A-A597-D15AFF11E858';
        const modelPath = this.props.model?.path || 'model.gltf'; 
        // Create GLTF loader
        const gltfLoader = new GLTFLoader(loadingManager);
        
        // Load the model
        const modelUrl = `${window.config.getApiBaseUrl()}/api/models/gltf/${modelId}/${modelPath}`;
        // const modelUrl = `http://${window.location.hostname}:5000/api/models/obj/123/Clamp.glb`;
        //console.log(`Loading model from: ${modelUrl}`);
        
        // Define base model color
        const baseColor = 0x999999; // Light gray base color
        const partColors = [
            // 0x8C9EFF, // Blue
            // 0x9CCC65, // Green
            // 0xFFB74D, // Orange
            0x4FC3F7 // Light blue
            // 0xF06292, // Pink
            // 0xBA68C8  // Purple
        ];
        
        gltfLoader.load(
            modelUrl,
            (gltf) => {
                //console.log('Model loaded successfully', gltf);
                
                const object = gltf.scene;
                
                // Look for mesh names and preserve them
                let partCounter = 0;
                const objectsMap = new Map();
                
                // First pass: identify groups based on object names
                object.traverse((child) => {
                    if (child.isMesh) {
                        // Create a unique group name from object name
                        const objName = child.name || `Part_${partCounter}`;
                        if (!objectsMap.has(objName)) {
                            objectsMap.set(objName, []);
                            partCounter++;
                        }
                        objectsMap.get(objName).push(child);
                    }
                });
                
                // Process meshes by group (using a consistent base color)
                objectsMap.forEach((meshes, objName) => {
                    const material = new THREE.MeshPhongMaterial({ color: 0xffffff });
                    
                    // Apply material and set name for each mesh in the group
                    meshes.forEach(mesh => {
                        // Store original material before setting the new one
                        mesh.material = material.clone();
                        mesh.userData.originalMaterial = material.clone();
                        mesh.name = objName;
                        mesh.userData.partGroup = objName;
                        mesh.userData.isPickable = true;
                        mesh.userData.isHighlighted = false;
                        mesh.userData.colorIndex = Array.from(objectsMap.keys()).indexOf(objName) % partColors.length;
                    });
                });
                
                // Debug output
                //console.log("Identified object groups:", Array.from(objectsMap.keys()));
                
                // Center the model
                const box = new THREE.Box3().setFromObject(object);
                const center = box.getCenter(new THREE.Vector3());
                const size = box.getSize(new THREE.Vector3());
                
                // Reset position to center
                object.position.x = -center.x;
                object.position.y = -center.y;
                object.position.z = -center.z;
                
                // Scale model to reasonable size if needed
                const maxDim = Math.max(size.x, size.y, size.z);
                if (maxDim > 10) {
                    const scale = 5 / maxDim;
                    object.scale.set(scale, scale, scale);
                }
                
                // Add model to scene
                this.scene.add(object);
                
                // Position camera to view the entire model
                const distance = Math.max(size.x, size.y, size.z) * 2;
                this.camera.position.set(distance, distance/1.5, distance);
                this.camera.lookAt(0, 0, 0);
                this.controls.update();
            },
            (xhr) => {
                // Loading progress
                const percent = (xhr.loaded / xhr.total) * 100;
                //console.log(`Model ${percent.toFixed(2)}% loaded`);
            },
            (error) => {
                // Error loading model
                console.error('Error loading GLTF model:', error);
            }
        );
    }




    handleWindowResize = () => {
        if (!this.threeJSContainer.current) return;
        
        // Update camera aspect ratio
        this.camera.aspect = this.threeJSContainer.current.clientWidth / this.threeJSContainer.current.clientHeight;
        this.camera.updateProjectionMatrix();
        
        // Update renderer size
        this.renderer.setSize(
            this.threeJSContainer.current.clientWidth, 
            this.threeJSContainer.current.clientHeight
        );
    }







    preventDefault =() =>{

    }

    handleClickOutside = (event) => {
        //console.log("click is caught")
        let outsideClick = (this.modelRef && !this.modelRef.current.contains(event.target)) && event.target.className !==  "model-canvas"
        let setting = document.getElementById("author-webgl-settings-container")
        if(this.props.showWebGLSettings && setting != null && !setting.contains(event.target)){
            this.props.setWebGLSettings(false);
        }
        if (outsideClick ) {
            //console.log("outside")
            this.unityContext.send(
                "Manager",
                "WebGLUseInputs",
                0
            );
            this.setState({
                webGLUsingInputs: false
            })
        } else {
            //console.log("inside")
           // if (!this.state.webGLUsingInputs) {              
                this.unityContext.send(
                    "Manager",
                    "WebGLUseInputs",
                    1
                );
                //this.unityContext.send("Manager","SetaAnnotationData");
                //this.unityContext.send("Manager","storeClickedAnnotation");
                this.setState({
                    webGLUsingInputs: true
                })
                
            //}
        }
    }


    downloadImage = (base64String) => {
        //downloads an image from a 3d Model and saves to users computer
        // return window.location.href = `${base64String)}`
        this.setState({
            capture: base64String
        }, this.startDownload)
    }
    startDownload = () => {
        document.getElementById("model-capture").click()
    }

    loadAssetBundles = () => {
        this.setState({ loadedAssetBundles: true },
            () => setTimeout(() => {
                let modelId = this.props.model.temp_model_id || this.props.model._id;
                //console.log(`http://${window.location.hostname}:5000/api/models/obj/${modelId}/${this.props.model.path}`)
                //console.log("json")
                //console.log(JSON.stringify({
                //     model_id: modelId,
                //     cameraData: this.state.cameraData,
                //     background_color: this.props.model.background_color ? this.props.model.background_color : "#ffffff"
                // }))
                this.unityContext.send(
                    "Manager",
                    "SendURL",
                    // `http://10.8.0.6:5000/api/models/obj/2D795762-F998-494B-AFAA-C8D802974CA1/landing_gear_new4.obj`
                    // `http://${window.location.hostname}:5000/api/models/${modelId}`
                    `${window.config.getApiBaseUrl()}/api/models/obj/${modelId}/${this.props.model.path}`
                )
                this.unityContext.send(
                    "Manager",
                    "LoadAssetBundle",
                    JSON.stringify({
                        model_id: modelId,
                        cameraData: this.state.cameraData,
                        background_color: this.props.model.background_color ? this.props.model.background_color : "#ffffff"
                    })
                )
            }, 1000))
    }

    sendAuth = async () => {
        let refreshToken = localStorage.getItem("refreshToken")
        let AccessToken = localStorage.getItem("accessToken")
        let refreshRes = await axios.post("api/users/refresh", { refreshToken: refreshToken })
        let token = `bearer ${refreshRes.data.accessToken}`
        //console.log("token here")
        //console.log(token)
        this.unityContext.send(
            "Manager",
            "SendAuth",
            token
        )
        this.setState({ authSent: true })
    }

    normalizeObject = (object) => {
        const targetSize = 10; // All models will be scaled to fit within a 10x10x10 cube.

        // 1. Scale the model to a uniform size.
        const initialBox = new THREE.Box3().setFromObject(object);
        const initialSize = initialBox.getSize(new THREE.Vector3());
        const maxDim = Math.max(initialSize.x, initialSize.y, initialSize.z);
        if (maxDim > 0) {
            const scaleFactor = targetSize / maxDim;
            object.scale.set(scaleFactor, scaleFactor, scaleFactor);
        }

        // 2. Center the scaled model at the origin.
        const scaledBox = new THREE.Box3().setFromObject(object);
        const center = scaledBox.getCenter(new THREE.Vector3());
        object.position.sub(center);

        // 3. Place the model on top of the grid (y=0).
        const finalBox = new THREE.Box3().setFromObject(object);
        object.position.y -= finalBox.min.y;
    }

    frameObject = (object, camera, controls) => {
        const padding = 1.5; // Controls how "zoomed out" the camera is. 1.0 is a tight fit.

        // First, normalize the object's scale and position.
        this.normalizeObject(object);
        
        // Get the model's new size and center point for camera framing.
        const box = new THREE.Box3().setFromObject(object);
        const size = box.getSize(new THREE.Vector3());
        const center = box.getCenter(new THREE.Vector3());
        const maxDim = Math.max(size.x, size.y, size.z);

        // Calculate the camera distance required to frame the object.
        const fov = camera.fov * (Math.PI / 180);
        const cameraDistance = Math.abs(maxDim / Math.tan(fov / 2)) / 2;

        // Position the camera to achieve a consistent 3/4 viewing angle.
        camera.position.set(
            center.x + cameraDistance,
            center.y + cameraDistance * 0.5,
            center.z + cameraDistance
        ).multiplyScalar(padding);

        // Point the camera at the center of the model.
        controls.target.copy(center);
        controls.update();
    };

    renderModel() {
        // let size = this.state.hasError || this.state.webGLLoading ? "0%" : "100%"
        return <div id="webGL-window" className={!this.props.callFromAuthor ? "flex-centered max-size" : "flex-centered fixedDisplay"}>
            <a id="model-capture" className="hidden" download="model-capture.png" href={this.state.capture} alt="hidden-capture-area"></a>
            {this.state.webGLLoading ? <CircularProgress  style={{marginLeft:"auto", marginRight:"auto", zIndex:"100",position:"absolute"}}/> : null}
            {this.state.modelsLoaded &&
                <WebGLSettings
                    fromAuthor={true}
                    toggleWebGLSettings={this.toggleWebGLSettings}
                    brightness={this.state.brightness}
                    displayWebGLSettings={this.props.showWebGLSettings}
                    setWebGLSettings={this.props.setWebGLSettings}
                    setBrightness={this.setBrightness}
                    unityContext={this.unityContext}
                    storeColor={this.storeColor}
                    adjustFlySpeed={(value) => this.unityContext.send(
                        "Manager",
                        "SetFlySpeed",
                        value
                    )}
                    adjustRotateSpeed={(value) => this.unityContext.send(
                        "Manager",
                        "SetRotateSpeed",
                        value
                    )}
                    adjustOrbit={(value) => this.unityContext.send(
                        "Manager",
                        "SetOrbitSpeed",
                        value
                    )}
                    adjustPan={(value) => this.unityContext.send(
                        "Manager",
                        "SetPanSpeed",
                        value
                    )}
                    adjustZoom={(value) => this.unityContext.send(
                        "Manager",
                        "SetZoomSpeed",
                        value
                    )}
                    captureModel={() => this.unityContext.send(
                            "Manager",
                            "TakeScreenShot"
                        )}
                    resetCameraData={() => this.unityContext.send(
                            "Manager",
                            "TakeScreenShot"
                        )}
                />} 
            {this.state.hasError === true ? <div>{this.state.errorMessage}</div> : null}
            <Unity  unityContext={this.unityContext} height="100%" width="100%" id="author_canvas" className={"model-canvas"}/>
        </div>
    }
    renderJSModel() {
        return <div 
                  id="webGL-window" 
                  className={!this.props.callFromAuthor ? "flex-centered max-size" : "flex-centered fixedDisplay"}
                  // Here we attach our Three.js container
                  ref={this.threeJSContainer}
                  style={{ width: '100%', height: '100%' }}
               >
                <ModelControls 
                    onShiftUp={this.onShiftUp}
                    onShiftDown={this.onShiftDown}
                    onShiftLeft={this.onShiftLeft}
                    onShiftRight={this.onShiftRight}
                    onShiftStop={this.onShiftStop} 
                    onTurnUp={this.onTurnUp}
                    onTurnDown={this.onTurnDown}
                    onTurnLeft={this.onTurnLeft}
                    onTurnRight={this.onTurnRight}
                    onTurnStop={this.onTurnStop}   // Pass the turn stop callback
                    onZoomInDown={this.onZoomInDown}
                    onZoomOutDown={this.onZoomOutDown}
                    onZoomStop={this.onZoomStop}
                />
               </div>
    }
    storeColor = (color, brightness) => {
        this.props.updateColor(color)
        this.setBrightness(brightness)
    }

    setBrightness = (bright) => {
        if (bright !== this.state.brightness) {
            this.setState({ brightness: bright })
        }
    }

    toggleWebGLSettings = (state) => {
        this.setState(prevState => ({ displayWebGLSettings: state }));
    };

    

    


    updateCamerandMousePosition =(event)=>{       
        //console.log(event);
        if(this.props.toggleAnnotation){
                    alert(this.state.cameraData)
                    //console.log("cameradata");
                    //console.log(this.state.cameraData);
        }
    }
    
    render() {
        return( 
            <div id="model-viewer-container" className="flex-centered max-width" ref={this.modelRef}>
                {this.props.model ? this.renderJSModel() : null}
            </div>
        )
    }

}

export default ModelDisplay
